import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { F0Dialog } from '@factorialco/f0-react'
import { EmployeesEmployeeSelectorInput } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import { useCreateTrainingClassMembership } from 'modules/trainings/hooks/TrainingClassMemberships/useCreateTrainingClassMembership'

export const AddParticipantsToClassModal = ({ employeeIds }: { employeeIds: number[] }) => {
  const { navigation } = useNavigation()
  const { id, classId } = useParams()
  const navigate = useNavigate()
  const { company } = useCurrentSession()
  const { createTrainingClassMemberships, loading } = useCreateTrainingClassMembership()

  const [selectedEmployees, setSelectedEmployees] = useState<EmployeesEmployeeSelectorInput>({
    type: 'manual',
    ids: [],
  })

  const navigateBack = () =>
    navigate(
      navigation.trainings.list.details_revamp.view.trainingClasses.detail.participants.fullPath({
        id: Number(id),
        classId: Number(classId),
      })
    )

  const onSubmit = async () => {
    const result = await createTrainingClassMemberships({
      trainingClassIds: [Number(classId)],
      selection: selectedEmployees,
      companyId: company.id,
    })

    const handled = handleResult(result, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t(
          'trainings.trainings_revamp.classes_sidepanel.participants.datatable.error'
        ),
      })
    })
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t(
          'trainings.trainings_revamp.classes_sidepanel.participants.datatable.success_add'
        ),
      })
    }
    navigateBack()
  }

  return (
    <F0Dialog
      isOpen
      onClose={navigateBack}
      title={i18n.t(
        'trainings.trainings_revamp.training_detail.employees_table.add_participants_modal.title'
      )}
      primaryAction={{
        label: i18n.t('trainings.trainings_revamp.classes_sidepanel.participants.datatable.select'),
        onClick: onSubmit,
        loading,
        disabled: loading,
      }}
      secondaryAction={{
        label: i18n.t('common.cancel'),
        onClick: navigateBack,
      }}
    >
      <EmployeeSelectorV2
        onChange={setSelectedEmployees}
        options={{
          asList: true,
        }}
        forcedFilters={{
          excludeIds: employeeIds,
        }}
        multiple
      />
    </F0Dialog>
  )
}
